import $ from 'jquery';

export default function newTabLinks(linkSelector) {
    if($(linkSelector).length) {
        $(linkSelector).filter(function() {
            return $(this).attr('href').match(/\.(pdf|doc|docx|ppt|pptx|xls|slxs)$/i);
        }).attr('target', '_blank');
    }
}